import { render, staticRenderFns } from "./message-plugin.vue?vue&type=template&id=5c641458&scoped=true"
import script from "./message-plugin.vue?vue&type=script&lang=ts"
export * from "./message-plugin.vue?vue&type=script&lang=ts"
import style0 from "./message-plugin.vue?vue&type=style&index=0&id=5c641458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c641458",
  null
  
)

export default component.exports